// extracted by mini-css-extract-plugin
export default {"sidebar_title":"_3DFg","sidebar_content":"_17qM","iconContainer":"Va_8"};